import { Card, CardContent, Typography, Grid, Skeleton, Tooltip } from "@mui/material";
import React, { Fragment } from "react";

interface TherapistTotalsData {
    totalTherapistCount: number, 
    totalValue: number,
    totalAuslastung: number,
    totalRxCount: number,
    totalGaps: number,
    totalGapsInHours: number,
}

interface TotalsProps {
    therapistTotalsData: TherapistTotalsData[],
    isLoading: boolean,
}

const TherapistStatsTotals: React.FC<TotalsProps> = ({ therapistTotalsData, isLoading }) => {
  return (
    <Grid container justifyContent="space-between" wrap="wrap" sx={{ mt: 2.5 }}>
      {isLoading ? (
        <Fragment>
          <Grid item xs={12} sm={6} md={2.25}>
            <Card className="therapist-card" elevation={4}>
              <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: 0, pb: 0, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }}>
                  <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>THERAPEUTEN</Typography>
                  <Typography variant="subtitle2" sx={{ margin: 0, padding: 0, }}>
                    <Skeleton width="50%" sx={{ ml: 4, padding: 0, }} />
                  </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.25}>
            <Card className="therapist-card" elevation={4} >
              <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: -1.5, pb: -1.5, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }} >
                <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>UMSATZ</Typography>
                <Typography variant="subtitle2" sx={{ margin: 0, padding: 0, }}>
                  <Skeleton width="50%" sx={{ ml: 4, padding: 0, }} />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.25}>
            <Card className="therapist-card" elevation={4}>
              <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: -1.5, pb: -1.5, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }}>
                <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>AUSLASTUNG</Typography>
                <Typography variant="subtitle2" sx={{ margin: 0, padding: 0, }}>
                  <Skeleton width="50%" sx={{ ml: 4, padding: 0, }} />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.25}>
            <Card className="therapist-card" elevation={4}>
              <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: -1.5, pb: -1.5, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }}>
                <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>RX</Typography>
                <Typography variant="subtitle2" sx={{ margin: 0, padding: 0, }}>
                  <Skeleton width="50%" sx={{ ml: 4, padding: 0, }} />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.25}>
            <Card className="therapist-card" elevation={4}>
              <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: -1.5, pb: -1.5, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }}>
                <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>LÜCKEN</Typography>
                <Typography variant="subtitle2" sx={{ margin: 0, padding: 0, }}>
                  <Skeleton width="50%" sx={{ ml: 4, padding: 0, }} />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Fragment> 
      ) : (
      therapistTotalsData.map((row, index) => (
        <Fragment key={index}>
          <Grid item xs={12} sm={6} md={2.25}>
            <Card className="therapist-card" elevation={4}>
              <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: -1.5, pb: -1.5, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }}>
                  <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>THERAPEUTEN</Typography>
                  <Typography variant="subtitle2" sx={{ mb: -0.5, padding: 0, color: "#1f71af", fontSize: 18 }}>
                    {row.totalTherapistCount}
                  </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.25}>
            <Card className="therapist-card" elevation={4} >
              <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: -1.5, pb: -1.5, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }} >
                <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>UMSATZ</Typography>
                <Typography variant="subtitle2" sx={{ mb: -0.5, padding: 0, color: "#1f71af", fontSize: 18 }}>
                  {new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(row.totalValue)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.25}>
            <Card className="therapist-card" elevation={4}>
              <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: -1.5, pb: -1.5, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }}>
                <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>AUSLASTUNG</Typography>
                <Typography variant="subtitle2" sx={{ mb: -0.5, padding: 0, color: "#1f71af", fontSize: 18 }}>
                  {new Intl.NumberFormat("de-DE", { style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.totalAuslastung)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.25}>
            <Card className="therapist-card" elevation={4}>
              <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: -1.5, pb: -1.5, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }}>
                <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>RX</Typography>
                <Typography variant="subtitle2" sx={{ mb: -0.5, padding: 0, color: "#1f71af", fontSize: 18 }}>
                  {row.totalRxCount}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={2.25}>
            <Tooltip title="in Stunden" arrow placement="top">
              <Card className="therapist-card" elevation={4}>
                <CardContent sx={{ backgroundColor: "white", pr: -1.75, pl: -1.75, pt: -1.5, pb: -1.5, mr: -1.75, ml: -1.75, mt: -1.5, mb: -1.5 }}>
                  <Typography align="center" variant="body1" sx={{ mt: 0.5, padding: 0, fontSize: 11 }}>LÜCKEN</Typography>
                  <Typography variant="subtitle2" sx={{ mb: -0.5, padding: 0, color: "#1f71af", fontSize: 18 }}>
                    {new Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(row.totalGapsInHours)}
                  </Typography>
                </CardContent>
              </Card>
            </Tooltip>
          </Grid>
        </Fragment>
      )))}
    </Grid>
  );
};

export default TherapistStatsTotals;